import { render } from "./ProfileTeaching.vue?vue&type=template&id=20639da2&scoped=true"
const script = {}

import "./ProfileTeaching.vue?vue&type=style&index=0&id=20639da2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20639da2"]])

export default __exports__